import React from 'react';
import { ITEMS_THEME } from './itemsTheme';

const t = ITEMS_THEME;

export function SectionHeading({ stripe, children, compact = false }) {
  if (compact) {
    return (
      <div className="flex items-center gap-1.5 mb-1">
        <span className={`h-3.5 w-0.5 shrink-0 rounded-full ${stripe}`} aria-hidden />
        <h3 className={`text-[10px] font-bold ${t.sectionHeadText} uppercase tracking-wide`}>{children}</h3>
      </div>
    );
  }
  return (
    <div
      className={`flex items-center gap-2.5 px-3 py-2.5 mb-2.5 rounded-md bg-gradient-to-r ${t.sectionHeadBg} border ${t.sectionHeadBorder} shadow-sm`}
    >
      <span className={`h-6 w-1 shrink-0 rounded-full ${stripe}`} aria-hidden />
      <h3 className={`text-sm font-bold ${t.sectionHeadText} tracking-tight`}>{children}</h3>
    </div>
  );
}

export const panelHeadingCls = 'text-sm sm:text-base font-bold tracking-tight text-slate-900';

export const statLabelCls = `text-[10px] font-bold uppercase tracking-wide ${t.statLabel}`;

export function FiltersHeading({ icon: Icon, theme = t }) {
  return (
    <div
      className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md ${theme.filtersHeadBg} border ${theme.filtersHeadBorder}`}
    >
      {Icon && <Icon className={`h-3.5 w-3.5 shrink-0 ${theme.filterIcon}`} aria-hidden />}
      <span className={`text-xs font-bold ${theme.filtersHeadText} uppercase tracking-wide`}>Filters</span>
    </div>
  );
}
